import sendContactForm from "./sendContactForm";
export const sendContactFormPromise = sendContactForm;